module.exports = __webpack_public_path__ + "img/slider-image-03-insanon.8d0ae5dd.png";